import { useGoogleOneTapLogin } from '@react-oauth/google';
import { useControllerSocialMediaContext } from '../../hooks/ControllerSocialMedia';

export default function GoogleOneTap() {
  const { googleHandleCredentialResponse } = useControllerSocialMediaContext();
  useGoogleOneTapLogin({
    onSuccess: (credentialResponse) => {
      if (credentialResponse?.credential)
        googleHandleCredentialResponse(credentialResponse.credential);
    },
    onError: () => {
      console.error('Google One Tap failed:');
    },
    use_fedcm_for_prompt: true
  });

  return null;
}
